module.exports = __webpack_public_path__ + "static/media/sneezingImage.9d105c80.png";